import { render } from "./CreatePayment2.vue?vue&type=template&id=f81d8a04"
import script from "./CreatePayment2.vue?vue&type=script&lang=js"
export * from "./CreatePayment2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__